import { getBannerAnchor, showLoggerLogLevel } from '../notification-util';
/**
 * Shows the notificationStructure dialog
 * @public
 * @param notificationStructure - The NotificationStructure object
 * @param tagName - The tag name to create prefix for the design system provider & notificationStructure component
 * @param notificationBoundary - target listener for the notification
 * @returns
 * */
export const showBanner = (notificationStructure, tagName, notificationBoundary) => {
    var _a;
    showLoggerLogLevel(notificationStructure);
    const tagPrefix = tagName.split('-')[0];
    const banner = document.createElement(`${tagPrefix}-banner`);
    const container = getBannerAnchor(notificationBoundary);
    if (((_a = container === null || container === void 0 ? void 0 : container.children) === null || _a === void 0 ? void 0 : _a.length) > 0) {
        banner.style.position = 'absolute';
        banner.style.top = '0';
        banner.style.left = '0';
        banner.style.width = '100%';
    }
    container.appendChild(banner);
    banner.notification = notificationStructure;
};
